import React, { useEffect, useState } from "react";
//import "./Celebrating.css";

const Celebrating = () => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        const generateRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

        const confettiCount = 80; // Increased particle count for a richer effect
        const newParticles = [];

        for (let i = 0; i < confettiCount; i++) {
            newParticles.push({
                id: `confetti-${i}`,
                top: `${generateRandomNumber(0, 100)}%`,
                left: `${generateRandomNumber(0, 100)}%`,
                width: `${generateRandomNumber(6, 10)}px`,
                height: `${generateRandomNumber(3, 6)}px`,
                animationDelay: `${generateRandomNumber(0, 30) / 10}s`,
                animationDuration: `${generateRandomNumber(2, 5)}s`,
                particleClass: `particle c${generateRandomNumber(1, 6)}`,
            });
        }

        setParticles(newParticles);
    }, []);

    return (
        <div className="Celebrating">
            {particles.map((particle) => (
                <span
                    key={particle.id}
                    className={particle.particleClass}
                    style={{
                        top: particle.top,
                        left: particle.left,
                        width: particle.width,
                        height: particle.height,
                        animationDelay: particle.animationDelay,
                        animationDuration: particle.animationDuration,
                    }}
                ></span>
            ))}
        </div>
    );
};

export default Celebrating;